import { createSelector, createSlice } from "@reduxjs/toolkit";
import { apiCallBegan } from "./api";

// redit stands for Redit

const slice = createSlice({
  name: "redit",
  initialState: {
    isbrVerified: false,
    verifyingbr: false,
    responseid: null,
    responsedoc: {},
    covers: [],
    coverimportances: [],
    showFailedFileUploadToast: false,
  },
  reducers: {
    // action => action handler
    storeResponseId: (redit, action) => {
      redit.responseid = action.payload;
    },

    brVerificationInitialized: (redit, action) => {
      redit.verifyingbr = true;
    },
    brVerified: (redit, action) => {
      redit.verifyingbr = false;
      redit.isbrVerified = true;
      redit.responsedoc = action.payload.responsedoc;
      redit.covers = action.payload.covers;
      redit.coverimportances = action.payload.coverimportances;
    },

    brVerificationFailed: (redit, action) => {
      redit.verifyingbr = false;
      redit.isbrVerified = false;
    },

    uploadFileInitialized: (redit, action) => {
      redit.responsedoc.files = "loading";
    },

    uploadFileSuccess: (redit, action) => {
      redit.responsedoc.files = action.payload.files;
    },

    uploadFileFailed: (redit, action) => {
      redit.showFailedFileUploadToast = !redit.showFailedFileUploadToast;
    },
  },
});

export const {
  storeResponseId,
  brVerificationFailed,
  brVerified,
  brVerificationInitialized,
  uploadFileFailed,
  uploadFileInitialized,
  uploadFileSuccess,
  changeSelectedFile,
} = slice.actions;

// action creators and selectors
export const verifyAndFetchingBrokerAgainstResponse = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/responses/fetchforresponseditscreen",
    method: "post",
    data: data,
    onStart: brVerificationInitialized.type,
    onSuccess: brVerified.type,
    onError: brVerificationFailed.type,
  });

export const uploadfile = (file) => (dispatch, getState) => {
  // prospect, responseid, insurercode, file
  let reditslice = getState().entities.redit;

  let { prospectid, insurercode, _id } = reditslice.responsedoc;

  let formData = new FormData();

  formData.append("prospectid", prospectid);
  formData.append("insurercode", insurercode);
  formData.append("responseid", _id);
  formData.append("filetoupload", file);

  dispatch(
    apiCallBegan({
      serviceUrl: process.env.REACT_APP_BASICSERVICE,
      url: "/api/responses/fileupload",
      method: "post",
      data: formData,
      onStart: uploadFileInitialized.type,
      onSuccess: uploadFileSuccess.type,
      onError: uploadFileFailed.type,
    })
  );

  return;
};

// selectors
export const getIsBrVerified = createSelector(
  (state) => state.entities.redit,
  (redit) => redit.isbrVerified
);

export const getVerifyingBr = createSelector(
  (state) => state.entities.redit,
  (redit) => redit.verifyingbr
);

export const getFiles = createSelector(
  (state) => state.entities.redit,
  (redit) => redit.responsedoc.files
);

export default slice.reducer;
